import { io } from 'socket.io-client';
import {
  BROKER_STATUS_UPDATE,
  CHART_PNL_LIVE_FEED,
  CHART_UNDERLYINNG_PNL_LIVE_FEED,
  EMIT,
  SYMBOL_LIVE_FEED,
  UNDERLYING_LIVE_FEED,
} from '../constants/ActionTypes';
import responseTypes from '../constants/ResponseTypes';
import responseCodes from '../constants/ResponseCodes';
// import { addNotification } from '../actions/notifications';
import { socketReconnect, socketDisconnect } from '../actions/connection';
import storage from '../storage';
import { USER_ID, TOKEN } from '../constants/cookies';
import {
  SUBSCRIBE_POSITION_UPDATES,
  ALGO_STATUS_UPDATE,
  HEALTH_STATUS,
  SUBSCRIBE_LITE_POSITION_UPDATES,
  ALGOS_HEALTH_STATUS,
} from '../constants/ActionTypes';

import { ALGO_ID } from '../constants/cookies';
import {
  fetchAlgosHealthStatus,
  fetchAlgosList,
  subscribeAlgosPositionUpdatesAll,
  unsubscribeAlgosPositionUpdatesAll,
} from '../stores/algos-list/actions';
import { timeoutPromise } from '../helpers/promises';
import { fetchAlgoByIdAndUpdateAlgoStatus } from '../stores/algo-edit-config/actions';
import {
  subscribeUnderlyingLiveFeed,
  unsubscribeUnderlyingLiveFeed,
} from '../stores/underlying-live-feed/actions';
import { fetchBrokers } from '../actions/brokers';
import { parseStringTojson } from '../helpers/json-data-parse';
import { getAlgoLiveFeedSymbols } from '../stores/algo-live/getters';
import {
  subscribeSymbolLiveFeed,
  unsubscribeSymbolLiveFeed,
} from '../stores/symbol-live-feed/actions';
import {
  getPnlChartAlgoListcached,
  getPnlChartClientIdListcached,
  getPnlChartUnderlyingDataUnderlyingName,
  getPnlFetchOptions,
} from '../stores/pnl-chart/getters';
import {
  subscribePnlGraphUpdate,
  subscribePnlUnderlyingGraphUpdate,
  unsubscribePnlGraphUpdate,
  unsubscribePnlUnderlyingGraphUpdate,
} from '../stores/pnl-chart/actions';

const { REACT_APP_GLIDE_WS_PATH: glideWsPath = '' } = process.env;

// this line will be removed after web socket is ready
// glideWsPath = window.location.host + window.location.search;

let getStore;

const socketMiddlewareInit = () => {
  const socket = io(glideWsPath, {
    transports: ['websocket'],
    auth: {
      [TOKEN]: storage.getItem(TOKEN),
      [USER_ID]: storage.getItem(USER_ID),
    },
  });

  const clientLogin = () => {
    console.log('debug:', '[SOCKET] connected', socket.id);

    socket.emit('message', {
      method: 'user_login',
      data: { [USER_ID]: storage.getItem(USER_ID) },
    });
  };

  const reconnect = async () => {
    // console.log('Reconnect');
    if (getStore) {
      getStore().dispatch(socketReconnect());

      if (window.location.pathname.startsWith('/algos')) {
        const [, , id = ''] = window.location.pathname.split('/');

        if (id.trim() === '') {
          await getStore().dispatch(fetchAlgosList());
          await timeoutPromise(500);
          await getStore().dispatch(fetchAlgosHealthStatus());
          await getStore().dispatch(unsubscribeAlgosPositionUpdatesAll());
          await getStore().dispatch(subscribeAlgosPositionUpdatesAll());
        } else {
          await getStore().dispatch(fetchAlgoByIdAndUpdateAlgoStatus(id));

          const symbols = getAlgoLiveFeedSymbols(getStore().getState());

          getStore().dispatch(unsubscribeSymbolLiveFeed(symbols));
          await timeoutPromise(200);
          getStore().dispatch(subscribeSymbolLiveFeed(symbols));
        }

        await getStore().dispatch(unsubscribeUnderlyingLiveFeed());
        await getStore().dispatch(subscribeUnderlyingLiveFeed());
      }

      if (window.location.pathname.startsWith('/pnl-chart')) {
        await getStore().dispatch(unsubscribePnlGraphUpdate());
        await getStore().dispatch(subscribePnlGraphUpdate());

        const underlying = getPnlChartUnderlyingDataUnderlyingName(
          getStore().getState()
        );

        if (underlying) {
          await getStore().dispatch(
            unsubscribePnlUnderlyingGraphUpdate(underlying)
          );
          await getStore().dispatch(
            subscribePnlUnderlyingGraphUpdate(underlying)
          );
        }
      }
    }

    socket.emit('message', {
      method: 'user_login',
      data: { [USER_ID]: storage.getItem(USER_ID) },
    });

    const url = window.location.href;

    if (url.includes('/algos/')) {
      const algoId = url.substring(url.lastIndexOf('/') + 1);

      if (algoId.trim() !== '') {
        socket.emit('message', {
          method: 'subscribe_position_updates',
          data: {
            [ALGO_ID]: algoId,
          },
        });
      }
    }
  };

  socket.on('connect', clientLogin);

  socket.io.on('reconnect', reconnect);

  socket.io.on('reconnect_attempt', () => {
    console.warn('[SOCKET_RECONNECT_ATTEMPT]');
  });

  socket.io.on('reconnect_error', (err) => {
    console.error('[SOCKET_RECONNECT_ERROR]', err);
  });

  socket.on('disconnect', (reason) => {
    console.warn('[disconnect]', reason);

    // ✅ CLEAN UP LISTENERS (IMPORTANT FOR v4)
    // Only cleanup on intentional client disconnect
    if (reason === 'io client disconnect') {
      socket.removeAllListeners();
      socket.io.removeAllListeners();
    }

    if (getStore) {
      getStore().dispatch(socketDisconnect(reason));
    }
  });

  socket.on('error', (error) => {
    // ignore posting notification if value is not string
    if (typeof error !== 'string') {
      console.dir(error);

      return;
    }

    console.log('Pass socket error', error);

    // if (getStore) {
    //   console.log('Pass socket error', error);

    //   getStore().dispatch(
    //     addNotification({
    //       type: 'error',
    //       message: error,
    //       silent: error && error === 'Unauthorized' ? true : false,
    //     })
    //   );
    // }
  });

  socket.on('connect_error', (err) => {
    console.error('[SOCKET_CONNECT_ERROR]', err.message);
  });

  const socketMiddleware = (store) => {
    socket.on('message', (response, dataRaw) => {
      const data = parseStringTojson(dataRaw);
      // console.log(response, data);

      let url = window.location.href;
      const algoId = url.substring(url.lastIndexOf('/') + 1);
      // console.log('message', message);
      const typeOrAction = responseTypes[response.response_type];
      const responseCode = responseCodes[response.response_code];

      if (typeOrAction) {
        // dispatch only if success is true OR success key is not assigned
        if (response.success === undefined || response.success) {
          if (typeof typeOrAction === 'function') {
            store.dispatch(typeOrAction({ data }));
          } else {
            // check if position update belongs to this page
            if (typeOrAction === SUBSCRIBE_POSITION_UPDATES) {
              if (data && data.algo && data.algo === algoId) {
                store.dispatch({ type: typeOrAction, data });
              }
            } else if (typeOrAction === HEALTH_STATUS) {
              if (
                data &&
                data.algo &&
                data.algo.id &&
                data.algo.id === algoId
              ) {
                store.dispatch({ type: typeOrAction, data });
              }

              if (data && data.algos) {
                store.dispatch({
                  type: ALGOS_HEALTH_STATUS,
                  data,
                });
              }
            } else if (typeOrAction === ALGO_STATUS_UPDATE) {
              if (algoId.startsWith('algos')) {
                // launch algo status update when on algos page
                store.dispatch({ type: typeOrAction, data });
              } else if (data && data.algo && data.algo === algoId) {
                store.dispatch({ type: typeOrAction, data });
              }
            } else if (typeOrAction === SUBSCRIBE_LITE_POSITION_UPDATES) {
              // launch when on algos page
              if (algoId.startsWith('algos')) {
                store.dispatch({ type: typeOrAction, data });
              }
            } else if (typeOrAction === BROKER_STATUS_UPDATE) {
              // launch when on algos page
              if (algoId.startsWith('algos')) {
                store.dispatch({ type: typeOrAction, data });

                if (data?.reloadBrokers) {
                  // force reload brokers
                  store.dispatch(fetchBrokers());
                }
              }
            } else {
              // Messages like position update
              store.dispatch({ type: typeOrAction, data });
            }
          }
        }
      } else if (responseCode) {
        if (responseCode === UNDERLYING_LIVE_FEED && !response.response_type) {
          store.dispatch({ type: UNDERLYING_LIVE_FEED, data });
        }

        if (responseCode === SYMBOL_LIVE_FEED && !response.response_type) {
          store.dispatch({ type: SYMBOL_LIVE_FEED, data });
        }

        // pnl feed
        let pnlChartBrokerListData = getPnlChartClientIdListcached(
          store.getState()
        );

        pnlChartBrokerListData = pnlChartBrokerListData
          .filter((item) => item.selected)
          .map((item) => `${item.name}:${item.clientId}`);

        let pnlChartAlgoListData = getPnlChartAlgoListcached(store.getState());

        pnlChartAlgoListData = pnlChartAlgoListData
          .filter((item) => item.selected)
          .map((item) => item.id);

        const pnlChartFetchOptions = getPnlFetchOptions(store.getState());

        if (responseCode === CHART_PNL_LIVE_FEED) {
          store.dispatch({
            type: CHART_PNL_LIVE_FEED,
            data,
            broker: pnlChartBrokerListData,
            algo: pnlChartAlgoListData,
            fetchOptions: pnlChartFetchOptions,
          });
        }

        if (responseCode === CHART_UNDERLYINNG_PNL_LIVE_FEED) {
          store.dispatch({ type: CHART_UNDERLYINNG_PNL_LIVE_FEED, data });
        }
      }

      if (response.status === 'error') {
        console.log('Pass socket error response.status', response.status);

        // if (response.errors && Object.keys(response.errors).length) {
        //   Object.values(response.errors).forEach((errorVal) => {
        //     store.dispatch(
        //       addNotification({
        //         type: 'error',
        //         message: errorVal,
        //       })
        //     );
        //   });
        // } else {
        //   store.dispatch(
        //     addNotification({
        //       type: 'error',
        //       message: response.message,
        //     })
        //   );
        // }
      }
    });

    getStore = () => store;

    return (next) =>
      (action = {}) => {
        if (action && action.type === EMIT) {
          // console.log('action', action);
          socket.emit('message', {
            ...action.payload,
            data: {
              ...action.payload.data,
            },
          });
        }

        // console.log('Middleware triggered', action);
        next(action);
      };
  };

  return socketMiddleware;
};

export default socketMiddlewareInit;
